import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";

import {createStore} from 'redux'
import {storeKit} from './store/store.js'
import ErrorBoundary from "./components/errors";


  ReactDOM.render(
      <Provider store={storeKit}>
      <BrowserRouter>
      {/* <ErrorBoundary> */}
        <App />
      {/* </ErrorBoundary> */}
      </BrowserRouter>  </Provider>
      , document.getElementById('root'));



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
